import React, {useEffect, useState} from 'react';
import './App.css';
import {RouterProvider} from "react-router-dom";
import {useIsAuthenticated, useMsal, useMsalAuthentication} from "@azure/msal-react";
import {loginRequest} from "./msal/authConfig";
import {InteractionType} from "@azure/msal-browser";
import {isJwtExpiringSoon} from "./msal/authHelper";
import {tokenService} from "./msal/tokenService";
import {initializeAuthenticatedFetch} from "./msal/authenticatedFetchService";

function App(props: { router: any }) {
    useMsalAuthentication(InteractionType.Redirect, { ...loginRequest });
    const { instance, inProgress, accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const [tokenInState, setTokenInState] = useState<string|null>();
    const [isAuthenticatedFetchReady, setIsAuthenticatedFetchReady] = useState<boolean>(false);
    
    useEffect(() => {
        async function getToken() {
            if (instance && inProgress == 'none' && accounts[0]) {
                if (accounts[0].idToken) {
                    tokenService.storeToken(accounts[0].idToken);
                }

                initializeAuthenticatedFetch(instance, accounts[0]);
                setIsAuthenticatedFetchReady(true);

                const token = await tokenService.getValidToken(instance, accounts[0]);
                setTokenInState(token);
            }
        }
        getToken();
    }, [instance, inProgress, accounts])

    const token = tokenService.getCachedToken();
    if (!isAuthenticated || !token || isJwtExpiringSoon(token, 5) || !isAuthenticatedFetchReady) {
        return <></>;
    }

    return (
        <div className="App" style={{height: "100%"}}>
            <RouterProvider router={props.router}/>
        </div>
    );
}

export default App;
